exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.v-textarea textarea {\n  line-height: 1.25rem;\n  padding-top: 4px;\n}\n", ""]);

// exports
